var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJcb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 172,
    viewBox: "0 0 229 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3617_14872)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3617_14872",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 229,
    height: 172
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.323 0.384766H0.643311V171.265H228.323V0.384766Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3617_14872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.143 104.135H188.573C189.043 104.135 190.133 103.975 190.603 103.975C193.733 103.345 196.393 100.535 196.393 96.6247C196.393 92.7147 193.733 90.0547 190.603 89.2747C190.133 89.1147 189.193 89.1147 188.573 89.1147H172.143V104.135Z",
    fill: "url(#paint0_linear_3617_14872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.693 0.384766C171.043 0.384766 158.213 13.0548 158.213 28.8648V58.4348H198.433C199.373 58.4348 200.463 58.4348 201.253 58.5948C210.333 59.0648 217.053 63.7548 217.053 71.8948C217.053 78.3148 212.513 83.7848 204.063 84.8848V85.1948C213.293 85.8248 220.333 90.9848 220.333 98.9648C220.333 107.575 212.513 113.205 202.183 113.205H158.053V171.105H199.833C215.483 171.105 228.313 158.435 228.313 142.625V0.384766H186.693Z",
    fill: "url(#paint1_linear_3617_14872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.363 73.7748C194.363 70.0148 191.703 67.5148 188.573 67.0448C188.263 67.0448 187.473 66.8848 187.013 66.8848H172.143V80.6548H187.013C187.483 80.6548 188.423 80.6548 188.573 80.4948C191.703 80.0248 194.363 77.5248 194.363 73.7648V73.7748Z",
    fill: "url(#paint2_linear_3617_14872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2833 0.384766C13.6333 0.384766 0.80332 13.0548 0.80332 28.8648V99.1248C8.78332 103.035 17.0733 105.545 25.3733 105.545C35.2333 105.545 40.5533 99.5948 40.5533 91.4648V58.2848H64.9633V91.3048C64.9633 104.135 56.9833 114.625 29.9133 114.625C13.4833 114.625 0.65332 111.025 0.65332 111.025V170.955H42.4233C58.0733 170.955 70.9033 158.285 70.9033 142.475V0.384766H29.2833Z",
    fill: "url(#paint3_linear_3617_14872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.983 0.384766C92.3334 0.384766 79.5034 13.0548 79.5034 28.8648V66.1048C86.7034 60.0048 99.2234 56.0948 119.403 57.0248C130.203 57.4948 141.783 60.4648 141.783 60.4648V72.5148C135.993 69.5448 129.113 66.8848 120.193 66.2548C104.863 65.1548 95.6234 72.6748 95.6234 85.8148C95.6234 98.9548 104.853 106.625 120.193 105.375C129.113 104.745 135.993 101.935 141.783 99.1148V111.165C141.783 111.165 130.363 114.135 119.403 114.605C99.2134 115.545 86.7034 111.635 79.5034 105.525V171.245H121.283C136.933 171.245 149.763 158.575 149.763 142.765V0.384766H107.983Z",
    fill: "url(#paint4_linear_3617_14872)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3617_14872",
    x1: 159.003,
    y1: 97.6149,
    x2: 229.328,
    y2: 97.6149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3617_14872",
    x1: 158.178,
    y1: 84.3964,
    x2: 228.438,
    y2: 84.3964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3617_14872",
    x1: 158.098,
    y1: 73.8958,
    x2: 228.536,
    y2: 73.8958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3617_14872",
    x1: 0.75772,
    y1: 87.4472,
    x2: 71.7203,
    y2: 87.4472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3617_14872",
    x1: 78.9252,
    y1: 83.0512,
    x2: 148.483,
    y2: 83.0512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3617_14872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 172,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJcb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/jcb.00582cca29ed21e690e610b3e518bf30.svg";